<template>
	<div class="personSet_page">
		<div class="study_content" v-for="(item,index) in study_content" :key="index">
			<div class="study_class_name"><p>{{item.study_title}}:</p></div>
			<ul>
				<li v-for="(teacher,index2) in item.teachers" :key="index2" @click="to_curriculum">
					<p class="teacher_describe">{{teacher.describe}}</p>
					<!--teacher_describe_img  teacher_photo 可换成img元素，也可在内部添加img（需添加图片样式）-->
					<div class="teacher_describe_img">
						<img src="https://static.wixstatic.com/media/a36401_830f1f96bf4b46578aa6780648f48a94~mv2.png/v1/fill/w_91,h_32,al_c,q_80,usm_0.66_1.00_0.01/2000px-London_school_of_economics_logo_w.webp">
					</div>
					<div class="teacher_photo">
						<img src="https://static.wixstatic.com/media/a36401_bf3b2dd9e1744bbe89747594703f933d~mv2_d_2162_3513_s_2.png/v1/fill/w_88,h_141,al_c,q_80,usm_0.66_1.00_0.01/purepng_com-business-manbusinessmanbusin.webp">
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'study',
	  data () {
	    return {
			study_content:[
				{
					study_title:'最近学习的课程',
					teachers:[
						{describe:'特许金融分析师1',describe_img:'',photo:''},
						{describe:'特许金融分析师2',describe_img:'',photo:''},
						{describe:'特许金融分析师3',describe_img:'',photo:''}
					]
				},
				{
					study_title:'最近添加的课程',
					teachers:[
						{describe:'特许金融分析师1',describe_img:'',photo:''},
						{describe:'特许金融分析师2',describe_img:'',photo:''},
						{describe:'特许金融分析师3',describe_img:'',photo:''}
					]
				},
				{
					study_title:'全部课程',
					teachers:[
						{describe:'特许金融分析师1',describe_img:'',photo:''},
						{describe:'特许金融分析师2',describe_img:'',photo:''},
					]
				},
			]
	    }
	  },
	  created() {
	  	document.documentElement.scrollTop = 0
	  },
	  methods:{
		  to_curriculum:function(){
			  this.$router.push("curriculum");
		  }
	  }
	}
</script>

<style scoped="scoped">
	.study_content{
		width:640px;
		float: right;
		margin-top:40px;
	}
	.study_content:first-child{
		margin-top:0;
	}
	.study_content .study_class_name p{
		height: 30px;
		line-height:30px;
		font-size:14px;
		color:#fff;
	}
	.study_content ul{
		position: relative;
		zoom: 1;
	}	
	.study_content ul li{
		width: 240px;
		height: 110px;
		float: left;
		margin-right: 100px;
		margin-top:40px;
		background-color:rgba(232,230,230);
		border-radius: 20px;
		padding:10px;
		cursor:pointer;
	}
	.study_content ul li:nth-child(2n){
		margin-right: 0px !important;
	}
	.study_content ul li .teacher_describe{
		width: 160px;
		height: 20px;
		margin-top:10px;
		font-size: 14px;
		color:rgba(65,65,65);
		text-indent: 30px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		position: absolute;
	}	
	.study_content ul li .teacher_describe_img{
		margin-top:60px;
		margin-left:40px;
		position: absolute;
	}
	.study_content ul li .teacher_describe_img img{
		width: 90px;
	}
	.study_content ul li .teacher_photo{
		width: 70px;
		height: 150px;
		float: right;
		margin-top:-20px;
		margin-right:-20px;
	}
	.study_content ul li .teacher_photo img{
		overflow: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/components/personSet/study.vue